/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReactElement } from 'react';
import Parameters from './Parameters';
import { DeviceAttributesV1, Group } from '../constants/telosair-interfaces';
import GroupComponent, { IndividualGroup } from './Group';
import { useData } from '../context/data.context';

type GroupsListComponentProps = {
  groups: Group[];
  sensors: number;
  selectedGroup: number | null;
  expandAll: boolean;
  setExpandAll: () => void;
  setSelectedDevice: (device: DeviceAttributesV1) => void;
  onGroupSelection: (data: number) => void;
  selectedFloor: number | null;
  selectedDevice: DeviceAttributesV1 | null;
};

/**
 * A Groups List Component.
 * @param props - Groups List Component Props.
 * @returns - A React Component.
 */
export default function GroupsList(props: GroupsListComponentProps): ReactElement {
  const {
    groups,
    selectedGroup,
    onGroupSelection,
    sensors,
    setSelectedDevice,
    selectedFloor,
    expandAll,
    setExpandAll,
    selectedDevice
  } = props;

  const { devices, loading } = useData();

  const filteredData = !selectedFloor
    ? groups
    : groups.filter((group) => selectedFloor === group.groupId);

  const mergedSensorDetailsList = ([] as any[]).concat(
    ...filteredData.map((item) => item.sensorDetailsList)
  );
  const otherGroup: Group = {
    floorPlan: '',
    groupId: -999,
    groupName: 'Other Devices',
    lastModifiedDate: '',
    sensorDetailsList: []
  };
  devices.forEach((item) => {
    const exists = mergedSensorDetailsList.filter(
      (device) => item.serialNumber === device.serial_number
    )[0];
    if (!exists) {
      otherGroup.sensorDetailsList.push({
        ...item,
        serial_number: item.serialNumber
      } as unknown as DeviceAttributesV1);
    }
  });

  return (
    <div className="rounded min-w-[50rem]">
      <Parameters
        expandAll={expandAll}
        setExpandAll={setExpandAll}
        groups={Object.keys(groups).length}
        sensors={sensors}
      />
      {filteredData.map((group, index) => (
        <GroupComponent
          selectedGroup={selectedGroup}
          key={group.groupId}
          expandAll={expandAll}
          index={index}
          groupDetails={group}
          onRowSelection={onGroupSelection}
          selectedDevice={selectedDevice}
          setSelectedDevice={setSelectedDevice}
        />
      ))}
      {!selectedFloor &&
        !loading &&
        otherGroup.sensorDetailsList?.length > 0 &&
        otherGroup?.sensorDetailsList?.map((currentDevice) => (
          <IndividualGroup
            noSpacingLeft
            isSelected={false}
            key={currentDevice.id}
            individualDevicedata={currentDevice}
            setSelectedDevice={setSelectedDevice}
            selectedDevice={selectedDevice}
          />
        ))}
    </div>
  );
}
